import { AbstractControl } from "@angular/forms";

export function startDateValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control.parent) return null;

  const startDate = control.value;
  const endDateControl = control.parent.get('endDate');
  const endDate = endDateControl?.value;

  // if (startDate) {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);
  //   const startDateOnly = new Date(startDate);
  //   startDateOnly.setHours(0, 0, 0, 0);

  //   if (startDateOnly < today) {
  //     return { startDateBeforeToday: true };
  //   }
  // }

  if (startDate && endDate && startDate >= endDate) {
    return { startDateAfterEndDate: true };
  }

  return null;
}

export function endDateValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control.parent) return null;

  const endDate = control.value;
  const startDateControl = control.parent.get('startDate');
  const startDate = startDateControl?.value;

  if (endDate && startDate && endDate <= startDate) {
    return { endDateBeforeStartDate: true };
  }

  return null;
}
